module.exports = __webpack_public_path__ + "static/media/dost_chatting.cff71819.png";